"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRepoPanelQueryParams = useRepoPanelQueryParams;
var React = _interopRequireWildcard(require("react"));
var _ProjectVisibility = require("../../Shared/Models/ProjectVisibility");
var _ArtifactEnablementApi = require("../../Shared/API/ArtifactEnablementApi");
var _MicrosoftGraphApi = require("../../Shared/API/MicrosoftGraphApi");
var _PermissionsError = _interopRequireDefault(require("../../Shared/errors/PermissionsError"));
var _AdoOrgApi = require("../../Shared/API/AdoOrgApi");
var _AzureDevOpsApi = require("../../Shared/API/AzureDevOpsApi");
var _ProductArtifactTypes = require("../../Shared/Models/ProductArtifactTypes");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) {
              if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            }
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) {
      keys.push(key);
    }
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) {
        ;
      }
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function useRepoPanelQueryParams() {
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    artifactIdentifier = _React$useState2[0],
    setArtifactIdentifier = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    artifactValidationError = _React$useState4[0],
    setArtifactValidationError = _React$useState4[1];
  var _React$useState5 = React.useState(true),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isLoading = _React$useState6[0],
    setIsLoading = _React$useState6[1];
  var _React$useState7 = React.useState(""),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    readableArtifactId = _React$useState8[0],
    setReadableArtifactId = _React$useState8[1];
  var _React$useState9 = React.useState(_ProjectVisibility.ProjectVisibility.Organization),
    _React$useState0 = _slicedToArray(_React$useState9, 2),
    projectVisibility = _React$useState0[0],
    setProjectVisibility = _React$useState0[1];
  var setArtifactValidationErrorWithTitle = function setArtifactValidationErrorWithTitle(message) {
    var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t("repositoryOwnerPanel.error.title");
    setArtifactValidationError({
      title: title,
      message: message
    });
  };
  var parseGithubArtifactUri = React.useCallback(function (gitHubArtifactUri) {
    var githubPrefix = "github://";
    if (!gitHubArtifactUri.startsWith(githubPrefix)) {
      setArtifactValidationErrorWithTitle("".concat(t("repositoryOwnerPanel.error.idMustStartWith"), " ").concat(githubPrefix));
    } else {
      setReadableArtifactId(gitHubArtifactUri.substring(githubPrefix.length));
    }
  }, []);

  /**
   * When a repository is disabled, calling ADO GET will return a 404 which prevents both the UI
   * and backend from looking it up and then assigning / classifying it. As a "temporary" fix,
   * the repo is temporarily re-enabled.
   *
   * 1. Try calling ADO GET. If that works, great, return it
   * 2. If it throws a PermissionsError
   *      a. Repository does actually does not exist
   *      b. User does not have view permissions
   *      c. Repository was disabled by our app
   *      d. Repository was disabled, but not by our app, such as directly through Azure Devops
   * 3. ADO LIST will include disabled repos which can then be used to determine if this is
   *      scenario a, b, c, or d.
   * 4. In case of scenario c or d, call the Artifact Enablement API to trigger the "break-glass" scenario
   *      which will temporarily re-enable the repo to allow assignment and classification
   */
  var tryGetRepository = React.useCallback(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(adoArtifactUri, orgName, projectId, repoId) {
      var repository, allRepos, me;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _AzureDevOpsApi.AzureDevOpsApi.getRepository(orgName, projectId, repoId);
            case 3:
              repository = _context.sent;
              _context.next = 30;
              break;
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              _context.next = 10;
              return _AzureDevOpsApi.AzureDevOpsApi.getRepositories(orgName, projectId);
            case 10:
              allRepos = _context.sent.value;
              repository = allRepos.find(function (r) {
                return r.id === repoId;
              });
              if (!(repository === undefined)) {
                _context.next = 14;
                break;
              }
              throw _context.t0;
            case 14:
              if (repository.isDisabled) {
                _context.next = 18;
                break;
              }
              throw new _PermissionsError.default("User does not have view permissions");
            case 18:
              _context.next = 20;
              return _MicrosoftGraphApi.MicrosoftGraphApi.me();
            case 20:
              me = _context.sent;
              _context.prev = 21;
              _context.next = 24;
              return _ArtifactEnablementApi.ArtifactEnablementApi.enable(_ProductArtifactTypes.ProductArtifactsTypes.Git, adoArtifactUri, {
                bypassRequestor: me.userPrincipalName,
                bypassReason: "Temporary hack from Product Catalog's repository ownership panel UI to enable disabled repos to allow assignment / classification."
              });
            case 24:
              _context.next = 30;
              break;
            case 26:
              _context.prev = 26;
              _context.t1 = _context["catch"](21);
              if (!_context.t1.message.startsWith("Tried to apply bypass to repository that was never disabled.")) {
                _context.next = 30;
                break;
              }
              throw new _PermissionsError.default(_context.t1.message);
            case 30:
              return _context.abrupt("return", repository);
            case 31:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 6], [21, 26]]);
    }));
    return function (_x2, _x3, _x4, _x5) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  var parseAdoArtifactUri = React.useCallback(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(adoArtifactUri) {
      var adoPrefix, guids, orgIndex, projectIndex, repoIndex, orgName, repository, _projectVisibility, _e$message, additionalErrorInfo;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              adoPrefix = "vsts://";
              if (adoArtifactUri.startsWith(adoPrefix)) {
                _context2.next = 5;
                break;
              }
              setArtifactValidationErrorWithTitle("".concat(t("repositoryOwnerPanel.error.idMustStartWith"), " ").concat(adoPrefix));
              _context2.next = 26;
              break;
            case 5:
              guids = adoArtifactUri.substring(adoPrefix.length).split("/");
              orgIndex = 0, projectIndex = 1, repoIndex = 2;
              if (!(guids.length !== 3)) {
                _context2.next = 11;
                break;
              }
              setArtifactValidationErrorWithTitle(t("repositoryOwnerPanel.error.idFormat"));
              _context2.next = 26;
              break;
            case 11:
              _context2.prev = 11;
              _context2.next = 14;
              return _AdoOrgApi.AdoOrgApi.getAdoOrg(guids[orgIndex]);
            case 14:
              orgName = _context2.sent.name;
              _context2.next = 17;
              return tryGetRepository(adoArtifactUri, orgName, guids[projectIndex], guids[repoIndex]);
            case 17:
              repository = _context2.sent;
              setReadableArtifactId("".concat(orgName, "/").concat(repository.project.name, "/").concat(repository.name));
              _projectVisibility = repository.project.visibility;
              setProjectVisibility(_projectVisibility);
              _context2.next = 26;
              break;
            case 23:
              _context2.prev = 23;
              _context2.t0 = _context2["catch"](11);
              if (_context2.t0 instanceof _PermissionsError.default) {
                setArtifactValidationErrorWithTitle(t("repositoryOwnerPanel.error.noAccessToRepoMessage"), t("repositoryOwnerPanel.error.noAccessToRepoTitle"));
              } else {
                additionalErrorInfo = (_e$message = _context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message) !== null && _e$message !== void 0 ? _e$message : Object.keys(_context2.t0).length > 0 ? _context2.t0 : "";
                setArtifactValidationErrorWithTitle("".concat(t("repositoryOwnerPanel.error.genericRequestFail"), " ").concat(additionalErrorInfo));
              }
            case 26:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[11, 23]]);
    }));
    return function (_x6) {
      return _ref2.apply(this, arguments);
    };
  }(), [tryGetRepository]);
  var parseUri = React.useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var _searchParams$get, _searchParams$get2;
    var searchParams, artifactType, artifactId;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            searchParams = new URLSearchParams(window.location.search);
            artifactType = (_searchParams$get = searchParams.get("artifactType")) !== null && _searchParams$get !== void 0 ? _searchParams$get : "";
            artifactId = (_searchParams$get2 = searchParams.get("artifactId")) !== null && _searchParams$get2 !== void 0 ? _searchParams$get2 : "";
            if (!(artifactType && artifactId)) {
              _context3.next = 7;
              break;
            }
            setArtifactIdentifier({
              artifactType: artifactType,
              artifactId: artifactId
            });
            _context3.next = 9;
            break;
          case 7:
            setArtifactValidationErrorWithTitle(t("repositoryOwnerPanel.error.missingQuery"));
            return _context3.abrupt("return");
          case 9:
            _context3.prev = 9;
            if (!(artifactType === _ProductArtifactTypes.ProductArtifactsTypes.GitHubRepo)) {
              _context3.next = 14;
              break;
            }
            parseGithubArtifactUri(artifactId);
            _context3.next = 20;
            break;
          case 14:
            if (!(artifactType === _ProductArtifactTypes.ProductArtifactsTypes.Git)) {
              _context3.next = 19;
              break;
            }
            _context3.next = 17;
            return parseAdoArtifactUri(artifactId);
          case 17:
            _context3.next = 20;
            break;
          case 19:
            setArtifactValidationErrorWithTitle("".concat(t("repositoryOwnerPanel.error.invalidArtifactType"), " ").concat(_ProductArtifactTypes.ProductArtifactsTypes.Git, " and ").concat(_ProductArtifactTypes.ProductArtifactsTypes.GitHubRepo, "."));
          case 20:
            _context3.next = 25;
            break;
          case 22:
            _context3.prev = 22;
            _context3.t0 = _context3["catch"](9);
            setArtifactValidationErrorWithTitle(_context3.t0.message);
          case 25:
            _context3.prev = 25;
            setIsLoading(false);
            return _context3.finish(25);
          case 28:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[9, 22, 25, 28]]);
  })), [parseGithubArtifactUri, parseAdoArtifactUri]);
  React.useEffect(function () {
    setIsLoading(true);

    // Page is being authenticated and will be redirected soon. When in this state, query parameters
    // are temporarily overridden so return early instead of trying to parse params that aren't there.
    if (window.location.hash.includes("id_token")) {
      return;
    }
    void parseUri();
  }, [parseUri]);
  var repoDetails = {
    name: "",
    location: ""
  };
  if (readableArtifactId) {
    var readableArtifactIdParts = readableArtifactId.split("/");
    repoDetails = {
      name: readableArtifactIdParts[readableArtifactIdParts.length - 1],
      location: readableArtifactIdParts.slice(0, readableArtifactIdParts.length - 1).join("/")
    };
  }
  var projectDetails = {
    visibility: projectVisibility
  };
  return {
    artifactIdentifier: artifactIdentifier,
    isLoadingArtifactIdentifier: isLoading,
    artifactValidationError: artifactValidationError,
    repoDetails: repoDetails,
    projectDetails: projectDetails
  };
}